/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Ajax Class.
 * Handles client/server communication over AJAX requests.
 */
var Ajax = function () {

  // constructor
  function Ajax(method, endpoint, options) {
    _classCallCheck(this, Ajax);

    this._options = Object.assign({
      // custom request headers object
      headers: {},
      // xhr expected response type from server
      type: 'text',
      // xhr timeout value (default: 10s)
      timeout: 10000,
      // data to be sent (string, selector, object, FormData, function)
      data: null,
      // custom handler before sending a request
      before: null,
      // progress custom handler
      progress: null,
      // error custom handler
      error: null,
      // success custom handler
      success: null,
      // complete custom handler
      complete: null
      // ...
    }, options);

    this._method = String(method || 'get').toUpperCase();
    this._endpoint = String(endpoint || '').trim();
    this._prefix = /\?.*$/.test(this._endpoint) ? '&' : '?';
    this._ctype = '';
    this._headers = {};
    this._complete = false;

    this._onProgress = this._onProgress.bind(this);
    this._onError = this._onError.bind(this);
    this._onLoad = this._onLoad.bind(this);
    this._onComplete = this._onComplete.bind(this);

    this._xhr = new XMLHttpRequest();
    this._xhr.upload.addEventListener('progress', this._onProgress, false);
    this._xhr.addEventListener('progress', this._onProgress, false);
    this._xhr.addEventListener('abort', this._onError, false);
    this._xhr.addEventListener('error', this._onError, false);
    this._xhr.addEventListener('timeout', this._onError, false);
    this._xhr.addEventListener('load', this._onLoad, false);

    this._setHeader('X-Requested-With', 'XMLHttpRequest');
    this._setHeader('Accept', 'application/json, text/plain, text/html, */*');
    this._applyHeaders(this._options.headers);
    this._send();
  }

  // call custom handler by name extracted from list or arguments


  _createClass(Ajax, [{
    key: '_callHandler',
    value: function _callHandler() {
      var args = [].slice.call(arguments);
      var name = args.length ? args.shift() : '';

      if (name && typeof this._options[name] === 'function') {
        this._options[name].apply(this, args);
      }
    }

    // set a header to be applied to the request

  }, {
    key: '_setHeader',
    value: function _setHeader(key, value) {
      key = String(key || '').replace(/[^\w\-]+/g, '').toLowerCase();
      value = String(value || '').trim();
      if (key) this._headers[key] = value;
    }

    // check if a header has been set

  }, {
    key: '_hasHeader',
    value: function _hasHeader(key) {
      key = String(key || '').replace(/[^\w\-]+/g, '').toLowerCase();
      return Object.keys(this._headers).indexOf(key) !== -1;
    }

    // apply headers from a given object

  }, {
    key: '_applyHeaders',
    value: function _applyHeaders(obj) {
      if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
        for (var key in obj) {
          if (!obj.hasOwnProperty(key)) continue;
          this._setHeader(key, obj[key]);
        }
      }
    }

    // convert form object into FormData object

  }, {
    key: '_getFormData',
    value: function _getFormData(form) {
      var fdata = new FormData(form);

      if (form instanceof HTMLFormElement) {
        for (var i = 0; i < form.elements.length; i++) {
          var elm = form.elements[i];

          if (elm.name && elm.type === 'checkbox') {
            fdata.set(elm.name, elm.checked ? 1 : 0);
          }
        }
      }
      return fdata;
    }

    // encode data as json string

  }, {
    key: '_jsonEncode',
    value: function _jsonEncode(data) {
      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
        try {
          var json = JSON.stringify(data);return json;
        } catch (e) {
          return JSON.stringify(e);
        }
      }
      return '{}';
    }

    // resolve data to be sent as URL query string

  }, {
    key: '_resolveQueryData',
    value: function _resolveQueryData(data) {
      var obj = {},
          pairs = [];
      this._ctype = 'application/x-www-form-urlencode; charset=UTF-8';

      // assume JSON string
      if (data && typeof data === 'string') {
        try {
          obj = JSON.parse(data);
        } catch (e) {}
        return this._resolveQueryData(obj);
      }
      // FormData object
      if (data instanceof FormData) {
        data.forEach(function (value, key) {
          obj[key] = value;
        });
        return this._resolveQueryData(obj);
      }
      // form element object
      if (data instanceof HTMLFormElement) {
        for (var i = 0; i < data.elements.length; i++) {
          var elm = data.elements[i];
          var value = elm.value || '';

          if (!elm.name || elm.type === 'file') continue;
          if (elm.type === 'checkbox') value = elm.checked ? 1 : 0;
          obj[elm.name] = value;
        }
        return this._resolveQueryData(obj);
      }
      // JS object
      if (data instanceof Object) {
        for (var key in data) {
          if (!data.hasOwnProperty(key) || /^\d+$/.test(key)) continue;
          if (/^(function|object)$/.test(_typeof(data[key]))) continue;
          pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
        }
        return pairs.join('&');
      }
      // all else
      return '';
    }

    // resolve data to be sent for request body

  }, {
    key: '_resolveRequestData',
    value: function _resolveRequestData(data) {
      // data is FormData object, send as is
      if (data instanceof FormData) {
        return data;
      }
      // data is FormElement object, convert to FormData
      if (data instanceof HTMLFormElement) {
        return this._getFormData(data);
      }
      // data is JS object/array, send as JSON
      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
        this._ctype = 'application/json; charset=UTF-8';
        return this._jsonEncode(data);
      }
      // data is a string, send as is
      if (typeof data === 'string') {
        return data;
      }
      // data is a function, pass output back to this function
      if (typeof data === 'function') {
        var output = data.call(this, this._xhr);
        return this._resolveRequestData(output);
      }
      // all else, send nothing
      return null;
    }

    // resolve data sent back from server based on provided responseType value

  }, {
    key: '_resolveResponseData',
    value: function _resolveResponseData() {
      return !this._options.type || this._options.type === 'text' ? this._xhr.responseText : this._xhr.response;
    }

    // resolve error string from a failed rersponse

  }, {
    key: '_resolveErrorText',
    value: function _resolveErrorText(response) {
      var status = this._xhr.status | 0;
      var statusText = this._xhr.statusText || 'Unknown status';

      // looks like a json response
      if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
        if (typeof response.error === 'string') return status + ': ' + response.error;
        if (typeof response.message === 'string') return status + ': ' + response.message;
        if (typeof response.info === 'string') return status + ': ' + response.info;
      }
      // generate a default error based on status
      if (status == 400) return status + ': The request could not be understood by the server due to malformed syntax.';
      if (status == 401) return status + ': You are not authorized to view the response of this request without authentication.';
      if (status == 403) return status + ': The server understood the request, but is refusing to fulfill it.';
      if (status == 404) return status + ': The server did not find anything matching the requested route.';
      if (status == 405) return status + ': The method specified for this request is not allowed for the current requested route.';
      if (status == 408) return status + ': The server did not produce a response in time for the requested route.';
      if (status == 500) return status + ': The server encountered an unexpected condition which prevented it from fulfilling the request.';
      return status + ': The request could not be completed for the requested route (' + statusText + ').';
    }

    // trigger custom progress handler

  }, {
    key: '_onProgress',
    value: function _onProgress(e) {
      if (!e.lengthComputable) return;
      var percent = Math.round(e.loaded * 100 / e.total);
      this._callHandler('progress', this._xhr, percent);
    }

    // trigger custom error handler

  }, {
    key: '_onError',
    value: function _onError(e) {
      var response = this._resolveResponseData();
      var error = this._resolveErrorText(response);
      this._callHandler('error', this._xhr, error, response);
      this._onComplete(response);
    }

    // trigger custom complete handler

  }, {
    key: '_onLoad',
    value: function _onLoad(e) {
      var status = this._xhr.status | 0;
      var response = this._resolveResponseData();
      var error = this._resolveErrorText(response);

      if (status && status < 400) {
        this._callHandler('success', this._xhr, response);
      } else {
        this._callHandler('error', this._xhr, error, response);
      }
      this._onComplete(response);
    }

    // final event to be triggered after everthing else has finished

  }, {
    key: '_onComplete',
    value: function _onComplete(response) {
      if (this._complete) return;
      this._callHandler('complete', this._xhr, response);
      this._complete = true;
      this._xhr = null;
    }

    // send new request

  }, {
    key: '_send',
    value: function _send() {
      var _this = this;

      var data = null;

      // send data as URL query, or body, based on request method
      if (this._method === 'GET') {
        var prefix = /\?.*$/.test(this._endpoint) ? '&' : '?';
        var query = this._resolveQueryData(this._options.data);
        this._endpoint += prefix + query;
      } else {
        data = this._resolveRequestData(this._options.data);
      }
      // open connection and apply options/headers
      this._xhr.open(this._method, this._endpoint, true);
      this._xhr.responseType = this._options.type || 'text';
      this._xhr.timeout = this._options.timeout | 0;

      // apply custom content type header if not already set
      if (this._ctype && !this._hasHeader('Content-type')) {
        this._setHeader('Content-type', this._ctype);
      }
      // apply all headers to request
      for (var key in this._headers) {
        if (this._headers.hasOwnProperty(key)) {
          (function () {
            var value = _this._headers[key];
            var words = key.split('-');
            words.forEach(function (word, i) {
              words[i] = word.charAt(0).toUpperCase() + word.slice(1);
            });
            _this._xhr.setRequestHeader(words.join('-'), value);
          })();
        }
      }
      // send request
      this._callHandler('before', this._xhr);
      this._xhr.send(data);
    }
  }]);

  return Ajax;
}();

/* harmony default export */ __webpack_exports__["a"] = (Ajax);
;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax__ = __webpack_require__(0);
/**
 * App scripts
 */


// page elements
var ajaxForm = document.querySelector('#ajaxform');
var progressBar = document.querySelector('#progressbar');
var statusBox = document.querySelector('#status');
var headersBox = document.querySelector('#headers');
var errorBox = document.querySelector('#error');
var dataBox = document.querySelector('#output');

// reset output boxes and progress
function resetBoxes() {
  progressBar.style.width = '0%';
  statusBox.value = '';
  headersBox.value = '';
  errorBox.value = '';
  dataBox.value = '';
};

// setup custom forms used to add key/val pairs used as headers or data params
function setupPairForms() {
  var pairs = document.querySelectorAll('[data-pairs]');

  var _loop = function _loop(i) {
    var elm = pairs[i];
    var inputs = elm.querySelectorAll('input');
    var btn = elm.querySelector('button');
    var list = document.querySelector(elm.getAttribute('data-pairs'));

    btn.addEventListener('click', function (e) {
      var key = inputs[0].value;
      var val = inputs[1].value;
      if (!key) return alert('Please provide a name for this entry.');

      var itm = document.createElement('li');
      itm.setAttribute('data-key', key);
      itm.setAttribute('data-value', val);
      itm.innerHTML = '<span>' + key + '&nbsp;:&nbsp;' + val + '&nbsp;&nbsp;&nbsp;&nbsp;</span>';

      var a = document.createElement('a');
      a.addEventListener('click', function (e) {
        e.preventDefault();itm.parentNode.removeChild(itm);
      });
      a.setAttribute('href', '#');
      a.innerHTML = '[delete]';

      itm.appendChild(a);
      list.appendChild(itm);

      inputs[0].value = '';
      inputs[1].value = '';
    });
  };

  for (var i = 0; i < pairs.length; ++i) {
    _loop(i);
  }
};

// get pairs data from list
function getPairData(listId) {
  var list = document.querySelector(listId);
  var data = {};

  if (list) {
    for (var i = 0; i < list.children.length; i++) {
      var itm = list.children[i];
      var key = itm.getAttribute('data-key');
      var val = itm.getAttribute('data-value');
      data[key] = val;
    }
  }
  return data;
};

// when the form is reset
ajaxForm.addEventListener('reset', function (e) {
  e.preventDefault();
  resetBoxes();
});

// when the form is submitted
ajaxForm.addEventListener('submit', function (e) {
  e.preventDefault();
  resetBoxes();

  // default headers and data
  var headers = getPairData('#headers-data');
  var params = getPairData('#params-data');
  var data = null;

  // params will be added to URL if sending a GET request
  if (this._method.value === 'GET') {
    data = params;
  } else {
    // sending params as form-data
    if (this._ctype.value === 'formdata') {
      data = new FormData();
      for (var name in headers) {
        if (/content\-type/gi.test(name)) delete headers[name];
      }for (var key in params) {
        data.append(key, params[key]);
      }for (var i = 0; i < this._files.files.length; i++) {
        data.append('files[]', this._files.files[i]);
      }
    }
    // sending params as url-encoded string
    if (this._ctype.value === 'urlencoded') {
      var pairs = [];
      for (var _key in params) {
        pairs.push(encodeURIComponent(_key) + '=' + encodeURIComponent(params[_key]));
      }headers['Content-Type'] = 'application/x-www-form-urlencoded';
      data = pairs.join('&');
    }
    // sending params as json string
    if (this._ctype.value === 'json') {
      headers['Content-Type'] = 'application/json';
      data = JSON.stringify(params);
    }
  }

  // send the ajax request
  new __WEBPACK_IMPORTED_MODULE_0__ajax__["a" /* default */](this._method.value, this._endpoint.value, {

    type: this._type.value,
    headers: headers,
    data: data,

    before: function before(xhr) {
      // console.log( 'onBefore', xhr );
      this._setHeader('Content-Type', 'application/json');
    },
    error: function error(xhr, _error, response) {
      errorBox.value = _error;
    },
    progress: function progress(xhr, percent) {
      progressBar.style.width = percent + '%';
    },
    success: function success(xhr, response) {
      // console.log( response );
    },
    complete: function complete(xhr, response) {
      statusBox.value = xhr.status;
      headersBox.value = xhr.getAllResponseHeaders();
      dataBox.value = response;
    }
  });

  // ...
});

// init
setupPairForms();
resetBoxes();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// public/bundles/app.min.js